import React, {Component} from "react";
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";
//import {browserHistory} from 'react-router';
import axios from "axios";
import {Button, Card, message, Spin, Table, Tabs} from 'antd';
import {toLocaleString} from "../Common/utils";

const TabPane = Tabs.TabPane;
import style from  "../index.less"
class MessageCenter extends Component {

  state = {
    loading: false,

    type: "",
    selfTypes: [],
    messages: [],

    selectRows: [],

    page: 0,
    size: 5,
    total: 0,
  };

  componentDidMount() {
    this.fetchData(this.props.userId, this.state.type, this.state.page, this.state.size);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchData(this.props.userId, this.state.type, this.state.page, this.state.size);
    }
  }

  render() {
    const titleTxt = this.language("user_service_message_msg_center_title");
    const publisherTxt = this.language("user_service_message_msg_center_publisher");
    const createdOnTxt = this.language("user_service_message_msg_center_createdOn");
    const typeTxt = this.language("user_service_message_msg_center_type");
    const panelTxt = this.language("user_service_message_msg_center_panel_title");
    const deleteTxt = this.language("user_service_message_msg_center_delete_btn");
    const markTxt = this.language("user_service_message_msg_center_mark_btn");
    const deleteSuccessTxt = this.language("user_service_message_msg_center_delete_success");
    const deleteFailTxt = this.language("user_service_message_msg_center_delete_fail");
    const readSuccessTxt = this.language("user_service_message_msg_center_read_success");
    const readFailTxt = this.language("user_service_message_msg_center_read_fail");


    const columns = [
      {
        title: titleTxt,
        dataIndex: 'title',
        key: 'title',
        render: (text, record, index) => <a
          onClick={() => this.onLinkClick.bind(this)(text, record, index)}>{text}</a>,
      },
      {
        title: publisherTxt,
        dataIndex: 'actor',
        key: 'actor',
      },
      {
        title: createdOnTxt,
        dataIndex: 'messageTime',
        key: 'messageTime',
        render: text => {
          return toLocaleString(text);
        }
      },
      {
        title: typeTxt,
        dataIndex: "type",
        key: 'type'
      }];

    const data = [
      {
        key: "1",
        title: "任务一",
        actor: "平台管理员",
        createdOn: '2018-03-15 08:45:08',
        type: "系统消息"
      },
      {
        key: "2",
        title: "ABCD版本发布",
        actor: "企业管理员",
        createdOn: '2018-01-11 09:30:08',
        type: "产品消息"
      },
      {
        key: "3",
        title: "XXX操作有可能会影响XXX的正常运行",
        actor: "平台管理员",
        createdOn: '2015-11-17 08:45:08',
        type: "安全消息"
      },
      {
        key: "4",
        title: "提交信息有误",
        actor: "平台管理员",
        createdOn: '2018-03-14 08:45:08',
        type: "服务消息"
      }
    ];

    const rowSelection = {
      selectedRowKeys: this.state.selectRows,
      onChange: (selectedRowKeys, selectedRows) => {
        console.debug(`MessageCenter: selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({
          selectRows: selectedRowKeys
        })
      },
      onSelect: (record, selected, selectedRows) => {
        console.debug("MessageCenter:", record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.debug("MessageCenter:", selected, selectedRows, changeRows);
      },
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User',    // Column configuration not to be checked
      }),
    };

    const pagination = {
      pageSize: this.state.size,
      current: this.state.page + 1,
      total: this.state.total,
      defaultCurrent: 1,
      defaultPageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ['5'],
      showQuickJumper: true,
      onShowSizeChange: (current, size) => {
        console.debug("MessageCenter: page", current, "size", size);
        this.fetchData(this.props.userId, this.state.type, 0, size);
      },
      onChange: (page) => {
        console.debug("MessageCenter: page", page);
        this.fetchData(this.props.userId, this.state.type, page - 1, this.state.size);
      }
    };

    // style={{background: "rgb(236,236,236)", padding: "24px", borderRadius: "8px", margin: "16px 0"}}
    return (
      <div>
        <Spin spinning={this.state.loading} size="large" >
          <Card title={panelTxt} bordered={false}  className={style.card}>
            <div style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop:10,
              background: "white",
            }} id="messageCenter">
              <Tabs defaultActiveKey="1" onChange={this.callback.bind(this)}>
                {
                  this.state.selfTypes.map(selfType =>
                    <TabPane tab={`${selfType}(${this.getSelfTypeCount(selfType)})`}
                             key={selfType}/>)
                }
              </Tabs>

              <Table columns={columns}
                     dataSource={this.state.messages}
                     rowSelection={rowSelection}
                     pagination={pagination}
                     size="middle"/>

              <div>
                <Button style={{marginRight: 4}}
                        disabled={this.state.selectRows.length === 0}
                        onClick={() => this.onDeleteClick.bind(this)(deleteSuccessTxt, deleteFailTxt)}>
                  {deleteTxt}
                </Button>
                <Button disabled={this.state.selectRows.length === 0}
                        onClick={() => this.onMarkReadClick.bind(this)(readSuccessTxt, readFailTxt)}>
                  {markTxt}
                </Button>
              </div>
            </div>
          </Card>
        </Spin>
      </div>
    )
  }

  getSelfTypeCount(selfType) {
    if (!!this.state.selfTypeCount) {
      if (!!this.state.selfTypeCount[selfType])
        return this.state.selfTypeCount[selfType];
      else
        return 0;
    } else {
      return 0;
    }
  }

  callback(key) {
    console.debug(`MessageCenter: select ${key}`);
    if (key === "全部消息")
      key = "";
    this.setState({
      type: key
    });
    this.fetchData(this.props.userId, key, this.state.page, this.state.size);
  }

  fetchData(user, type, page, size) {
    this.setState({
      loading: true
    });
    axios({
      // NOTE: requirement change - 2019/02/25 - remove is read flag.
      // url: `/api-user/userNotifications?userId=${user}&read=false&type=${type}&page=${page}&size=${size}`,
      url: `/api-user/userMessages?userId=${user}&type=${type}&page=${page}&size=${size}`,
      method: "GET"
    }).then(
      response => {
        console.debug("MessageCenter: GET /messages", response.data);
        this.setState({
          type: type,
          messages: response.data.content.map(c => ({
            action: c.action,
            actor: c.actor,
            description: c.description,
            messageTime: c.messageTime,
            key: c.notificationObjectId,
            hasRead: c.hasRead,
            selfDefinedType: c.selfDefinedType,
            title: c.title,
            type: c.type,
            updateTime: c.updateTime,
          })),
          page: response.data.pageable.pageNumber,
          size: response.data.pageable.pageSize,
          total: response.data.totalElements
        });
        return response;
      },
      err => {
        console.error("MessageCenter: GET /messages", err);
      }
    ).then(
      response => {
        return axios({
          url: `/api-user/messageSelfDefinedTypes`,
          method: "GET"
        })
      }
    ).then(
      response => {
        console.debug("MessageCenter: GET /messageSelfDefinedTypes", response.data);
        this.setState({
          loading: false,
          selfTypes: response.data.map(d => d.name)
        });
        return response.data
      },
      err => {
        console.error("MessageCenter: GET /messageSelfDefinedTypes", err);
      }
    ).then(
      response => {
        return axios({
          url: `/api-user/messageSelfDefinedTypesCount?userId=${this.props.userId}`,
          method: "GET"
        })
      }
    ).then(
      response => {
        console.debug("MessageCenter: GET /self-type-count", response.data);
        let newSelfTypeCount = {};
        let totalCount = 0;
        response.data.forEach(d => {
          newSelfTypeCount[d.selfType] = d.count;
          totalCount += d.count;
        });
        newSelfTypeCount["全部消息"] = totalCount;
        this.setState({
          selfTypeCount: newSelfTypeCount
        })
      },
      err => {
        console.error("MessageCenter: GET /self-type-count", err);
      }
    ).catch(
      ex => {
        console.error("MessageCenter: GET /messages", ex);
      }
    )
  }

  onLinkClick(text, record, index) {
    console.debug("MessageCenter: click link", text, record, index);
    this.props.dispatch({
      type: "/message-center/CLICK_LINK",
      data: record.key
    });
    this.props.history.push("/console/message-detail");
  }

  onDeleteClick(deleteSuccessTxt, deleteFailTxt) {
    console.debug("MessageCenter: click delete");
    axios({
      url: `/api-user/userNotifcations`,
      method: "DELETE",
      data: {
        notifications: this.state.selectRows.join(","),
        userId: this.props.userId
      }
    }).then(
      response => {
        message.success(deleteSuccessTxt);
        this.fetchData(this.props.userId, this.state.type, this.state.page, this.state.size);
      }
    ).catch(
      ex => {
        message.error(deleteFailTxt);
      }
    )
  }

  onMarkReadClick(readSuccessTxt, readFailTxt) {
    console.debug("MessageCenter: click read", this.state.selectRows);
    axios({
      url: `/api-user/userNotificationsRead`,
      method: "POST",
      data: {
        notifications: this.state.selectRows.join(","),
        userId: this.props.userId
      }
    }).then(
      response => {
        message.success(readSuccessTxt);
        this.fetchData(this.props.userId, this.state.type, this.state.page, this.state.size);
      }
    ).catch(
      ex => {
        message.error(readFailTxt);
      }
    )

  }

  language(value) {
    return this.props.intl.formatMessage({id: value});
  }
}

export const messageCenterReducer = (state = {clickId: ""}, action) => {
  switch (action.type) {
    case "/message-center/CLICK_LINK":
      return {
        ...state,
        clickId: action.data
      };
    default:
      return state
  }
};

export const mapStateToProps = (state) => ({
  clickId: state.messageCenterReducer.clickId,
  username: state.authentication.username,
  userId: state.authentication.userId
});

export const mapDispatchToProps = (dispatch) => ({
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MessageCenter));
